import {
  GasDistributionStationGasThreads,
  GasDistributionStationInformation,
} from '@gasbi/shared/web/Gds';
import { RouteObject } from 'react-router-dom';

import { Pages } from '@/pages';

export const gdsGasDistributionStationDetailsRoutes: RouteObject[] = [
  {
    element: <GasDistributionStationInformation />,
    index: true,
  },
  {
    path: Pages.GAS_THREADS,
    element: <GasDistributionStationGasThreads />,
  },
];
